import React, { useState, useEffect, useContext } from 'react';
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import { useTranslation } from 'react-i18next';
import { getContentWithAction, getContentWithActionAndLanguage } from '../../apiConnect';
import { useAlert } from 'react-alert'
import AppContext from '../../AppContext';
import FeatureInfoPane from './FeatureInfoPane';
import { preparePhotos } from '../../commonFunctions';
import { BsArrowReturnLeft } from "react-icons/bs";

import '../../css/general.css'
import '../../css/mobiNewStyles.css'
import ObservationSharingModal from './ObservationSharingModal';
import { GetExtraMeasurements } from '../../Constants/MeasurementTypes.js';

const SharedFeaturesList = (props) => {
    const { t } = useTranslation();
    const { auth } = useContext(AppContext);
    const alert = useAlert();

    const [features, setFeatures] = useState([]);
    const [resources, setResources] = useState({ observationTypes: [], observationMeasures: [] });
    const [loading, setLoading] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [selectedFeature, setSelectedFeature] = useState(null);
    const [photosLoaded, setPhotosLoaded] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);

    useEffect(() => {
        if (!props.show) return;

        setLoading(true);
        Promise.all([
            getContentWithAction(auth.getAccessToken(), 'map', 'getFarmSharedFeatures', {}),
            getContentWithAction(auth.getAccessToken(), 'resource', 'observe', {}),
            getContentWithActionAndLanguage(auth.getAccessToken(), 'resource', 'observationMeasure', {}),
        ]).then(([sharedFeatures, observationTypes, observationMeasures]) => {
            observationMeasures = observationMeasures.concat(GetExtraMeasurements(t));
            setResources({
                observationTypes: observationTypes || [],
                observationMeasures: observationMeasures || []
            });

            const featureList = sharedFeatures || [];
            setFeatures(featureList);
            setPhotosLoaded(false);
            setLoading(false);

            const photoPromises = featureList.map(feature =>
                getContentWithAction(auth.getAccessToken(), 'photo', 'sharedPhotos', { sharedFeatureId: feature.sharedFeatureId })
                    .then((data) => ({ ...feature, photos: preparePhotos(data) || [] }))
                    .catch(() => ({ ...feature, photos: [] }))
            );

            Promise.all(photoPromises).then((featuresWithPhotos) => {
                setFeatures(featuresWithPhotos);
                setPhotosLoaded(true);
            });
        }).catch(() => {
            alert.show(t('ErrorWhileFetchingData'));
            setLoading(false);
        });
    }, [props.show, refreshKey]);

    return (
        <>
            <Modal show={props.show} onHide={props.onHide} >
                <Modal.Header closeButton>
                    <Modal.Title className="text-dark">
                        {t('OwnShared')}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loading ? (
                        <div className="text-center"><Spinner animation="border" variant="mmfi-new" /></div>
                    ) : features.length > 0 ? (
                        features.map((feature, index) => (
                            <>
                                <FeatureInfoPane
                                    className="shared-list-pane"
                                    key={index}
                                    feature={feature}
                                    resources={resources}
                                    images={feature.photos && feature.photos.length > 0 ? feature.photos : []}
                                    imagesLoading={!photosLoaded}
                                    onClick={(object) => {
                                        let eventData = { ...object };
                                        eventData.isNew = false;
                                        setSelectedFeature(eventData);
                                        setShowEditModal(true);
                                        setLoading(true);
                                    }}
                                />
                            </>
                        ))
                    ) : (
                        <div className="text-center">{t('NoData')}</div>
                    )}
                </Modal.Body>
                <Modal.Footer className="modal-footer-right-align">
                    <Button variant="new-outline-secondary" onClick={() => { props.onHide(); }}><BsArrowReturnLeft style={{marginRight: "5px" } } />{t('Cancel')}</Button>
                </Modal.Footer>
            </Modal>

            {showEditModal &&
                <ObservationSharingModal
                    show={showEditModal}
                    eventdata={selectedFeature}
                    onSaved={() => {
                        setSelectedFeature(null);
                        setRefreshKey(prev => prev + 1);
                        props.onSaved();
                    }}
                    onHide={() => {
                        setLoading(false);
                        setShowEditModal(false);
                    }}
                />
            }
        </>
    );
}

export default SharedFeaturesList;